import {useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { VerifyToken } from '../apis/login';

import { login } from '../store/slices/authSlice'

const AuthProvider = ({children}) => {
    const dispatch = useDispatch()
    const pathname = window.location.pathname

    const checkToken = async () =>{
        const AUTH_TOKEN = localStorage.getItem('accessToken')
        if(AUTH_TOKEN){
            let result = await VerifyToken()
            if(result.status === 200){
                dispatch (login(
                    {
                        userId : result.data.userId,
                        userName : result.data.adiSoyadi,
                        userRole : result.data.role,
                        isAuthenticated : true,
                        userEnstituId : result.data.enstituId,
                        userEnstituName : result.data.enstituName
                    }
                ))
            }
        }
    }

    useEffect(() => {
        if(pathname !== '/login' || pathname !== '/register-control' || pathname !== '/register'){
            checkToken()
        }
        //eslint-disable-next-line
    }, []);

    return children
}

export default AuthProvider;
